export const LightningIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="5" height="10" fill="none">
    <path
      fill="#FDC202" // ad hoc color
      d="M4.944 4.43a.51.51 0 0 0-.45-.288h-1.8L4.15 1.065c.094-.196.05-.41-.111-.511-.134-.085-.34-.08-.49.118L.106 5.003a.534.534 0 0 0-.05.551.504.504 0 0 0 .45.287h1.8L.84 8.946c-.106.23-.011.428.116.512.05.034.112.05.178.05.1 0 .217-.044.306-.163l3.45-4.359a.534.534 0 0 0 .05-.551l.005-.006Z"
    />
  </svg>
);
